function getCount(count) {
  if (count >= 1) {
    if (count > 1000) {
      const r = (count / 1000).toString().slice(0, 4) + "K";
      return r;
    } else {
      return count;
    }
  } else {
    return "--";
  }
}

var formatter = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",

  // These options are needed to round to whole numbers if that's what you want.
  // minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  // maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});

export { getCount, formatter };
